import React, { Component } from "react";
import AdmissionApi from "../../Services/AdmissionApi";
import { Link } from "react-router";
import ReactLoading from "react-loading";
import Paging from "../Paging";
import StudentSideBar from "../StudentSideBar";
import moment from "moment";

import "./style.css";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import StudentAppBar from "../StudentAppBar";

import PropTypes from "prop-types";

class Scholarship extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: window.innerWidth < 980 ? false : true,
      scholarship: [],
      showLoading: true,
      scholarshipName: "",
      sponsoringInstitution: "",
      amountFrom: "",
      amountTo: "",
      page: 1,
      pageSize: 6,
      totalPages: 1,
    };

    this.handlePageChange = this.handlePageChange.bind(this);
    this.admissionsService = new AdmissionApi();
  }

  updateState = (response) => {
    this.setState({
      scholarship: response.data._embedded.scholarships,
      showLoading: false,
      page: response.data.page,
      totalPages: response.data.pageCount,
    });
  };

  static get contextTypes() {
    return {
      router: PropTypes.object.isRequired,
    };
  }

  UNSAFE_componentWillMount() {
    const isLogin = localStorage.getItem("isLogin");

    if (isLogin == 1) {
      this.getAll()
    } else {
      this.context.router.push("/signIn")
    }
  }

  getAll(page = 1) {
    let filters = ''
    const {
      scholarshipName,
      sponsoringInstitution,
      amountFrom,
      amountTo,
    } = this.state

    if (scholarshipName) filters += `&name=${scholarshipName}`
    if (sponsoringInstitution) filters += `&sponsoring_institution=${sponsoringInstitution}`
    if (amountFrom) filters += `&amount_from=${amountFrom}`
    if (amountTo) filters += `&amount_to=${amountTo}`


    this.admissionsService.GetData(
      this.updateState,
      `v1/alerts/scholarships?page=${page}&pageSize=${this.state.pageSize}&column=created_at&order=desc&userId=${localStorage.getItem('userId')}&userRole=student${filters}`
    );
  }

  handleFilterInputChange = (event) => {
    const { id, value } = event.target
    this.setState({
      [id]: value
    })
  }

  filterList = (e) => {
    e.preventDefault()
    this.getAll()
  }

  clearFilter = () => {
    this.setState({
      scholarshipName: '',
      sponsoringInstitution: '',
      amountFrom: '',
      amountTo: '',
    }, this.getAll)
  }

  handlePageChange = (page) => {
    this.getAll(page)
  }

  toggleSidebar = () => {
    this.setState(state => ({ isOpen: !state.isOpen }))
  }

  handleRequestChange = (isOpen) => {
    this.setState({ isOpen })
  }

  cbFavSuccess = (res) => {
    if (res.data.success === true) {
      this.getAll(this.state.page)
    }
  }

  onApplyNow = (data) => {
    let obj = {
      alertType: 2, // 1 for admission alerts and 2 for scholarship
      alertId: data.id,
      userRole: 'student',
      userId: localStorage.getItem('userId')
    }

    this.admissionsService.createNew(
      this.cbFavSuccess,
      obj,
      `v1/alerts/favourites`
    )
  }

  render() {
    const {
      page,
      totalPages,
      scholarship,
      scholarshipName,
      sponsoringInstitution,
      amountFrom,
      amountTo,
      isOpen
    } = this.state

    return (
      <MuiThemeProvider>
        <div className="dash-container">
          <StudentSideBar isOpen={isOpen} handleRequestChange={this.handleRequestChange} />

          <div className="dash-content">
            <StudentAppBar title="Scholarship Alerts" toggleSidebar={this.toggleSidebar} router={this.props.router} />
            <div className="container">
              <section className="dash-alerts">
                <form>
                  <div className="alert-filter">
                    <input
                      id="scholarshipName"
                      type="text"
                      className="form-control alert-filter__input mr-2"
                      placeholder="Scholarship Name"
                      value={scholarshipName}
                      onChange={this.handleFilterInputChange}
                    />
                    <input
                      id="sponsoringInstitution"
                      value={sponsoringInstitution}
                      type="text"
                      className="form-control alert-filter__input mr-2"
                      placeholder="Sponsoring institution"
                      onChange={this.handleFilterInputChange}
                    />
                    <input
                      id="amountFrom"
                      value={amountFrom}
                      type="number"
                      className="form-control alert-filter__input mr-2"
                      placeholder="Amount From"
                      onChange={this.handleFilterInputChange}
                    />
                    <input
                      id="amountTo"
                      value={amountTo}
                      type="number"
                      className="form-control alert-filter__input mr-2"
                      placeholder="Amount To"
                      onChange={this.handleFilterInputChange}
                    />
                    <button type="submit" onClick={this.filterList} className="btn btn--primary">
                      Submit
                    </button>
                    <button type="button" onClick={this.clearFilter} className="btn btn--default ml-2">
                      Clear
                    </button>
                  </div>
                </form>
                <table className="table table-responsive alert-table">
                  <thead>
                    <tr>
                      <th scope="col">Scholarship Name</th>
                      <th scope="col">Sponsoring Institution</th>
                      <th scope="col">Amount</th>
                      <th scope="col">Last Date to Apply</th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {scholarship.map(item => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>{item.sponsoring_institution}</td>
                        <td>{item.amount}</td>
                        <td>{moment(item.scholarship_last_date).format('DD/MM/YYYY')}</td>
                        <td className="d-flex">
                          <Link title="Click to view details" to={{ pathname: "/scholarshipDetail", state: { data: item } }} className="btn btn-link alert-table__link">
                            <i className="icon-eye fw-bold" />
                          </Link>
                          <button title={!item.isFavourite ? 'Save this alert to your favourites' : 'Remove this alert to your favourites'} className="btn btn-link alert-table__link" onClick={() => this.onApplyNow(item)}>
                            {!item.isFavourite ? (
                              <i className="icon-heart fw-bold" style={{ color: item.isFavourite ? 'red' : null }} />
                            ) : 
                            (
                              <svg xmlns="http://www.w3.org/2000/svg" style={{ color: 'red', width: 20 }} viewBox="0 0 20 20" fill="currentColor">
                                <path fill-rule="evenodd" d="M3.172 5.172a4 4 0 015.656 0L10 6.343l1.172-1.171a4 4 0 115.656 5.656L10 17.657l-6.828-6.829a4 4 0 010-5.656z" clip-rule="evenodd" />
                              </svg>
                            )}
                          </button>
                        </td>
                      </tr>
                    ))}
                    {!scholarship.length && (
                      <tr>
                        <td colSpan={2}>No Alerts Available!</td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <Paging page={page} totalPages={totalPages} onChange={this.handlePageChange} />
              </section>
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    )
  }
}

export default Scholarship;



/** WEBPACK FOOTER **
 ** ./src/components/Scholarship/index.js
 **/